export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const FETCH_COUNTRIES = 'FETCH_COUNTRIES';
